module.exports = __webpack_public_path__ + "static-portal/img/news12-1.d2c8c11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news12-1.jpg
// module id = Agta
// module chunks = 4